"use strict";

module.exports = require("../Public/preload/form.js");
